<div class="mt-8 w-full flex justify-center">

  <div class="wallet flex justify-center flex-col items-center">
    <p class="text-lg text-center mb-3">
      Select a wallet to pay with 
    </p>

    <div class="flex flex-wrap justify-center w-10/12 items-center border-soft bg-gray-300 overflow-y-auto p-2 min-h-150 min-w-250" style="border-radius: 12px;">

      <mat-spinner
      *ngIf="loading"
      class="loading-spinner"
      [color]="color"
      [diameter]="diameter"
      >
      </mat-spinner>

      <span class="w-full flex flex-wrap justify-center" *ngIf="!loading">
        <span class="flex flex-wrap w-1/6 justify-center wallet-method items-center m-2 hpx-100" *ngFor="let paymentOption of paymentOptions" (click)="chooseWallet(paymentOption['name'], paymentOption['logoUrl'], paymentOption['paymentOptionId'])">
          <img class="hpx-75 p-3" src='{{paymentOption["logoUrl"]}}' id='{{ paymentOption["paymentOptionId"] }}' name='{{ paymentOption["name"] }}' >
        </span>
      </span>

    </div>

  </div>
</div>